/**
 * @module ProductsList
 */

import Component from '../base/Component';
import './styles.css';

/**
 * Раздел UI Kit.
 */
export default class ProductsList extends Component {
    static className = 'products-list';
}
